import axios from "axios";
import { baseUrl } from "../config/api-config";

const auth = (token) => ({ headers: { authorization: token } });

export function getCaseStage(token, caseId) {
  return axios.get(`${baseUrl}/case/${caseId}/stage`, auth(token));
}

export function setCaseStage(token, caseId, body) {
  return axios.post(`${baseUrl}/case/${caseId}/stage`, body, auth(token));
}

export function assignCaseArbitrator(token, caseId, userId) {
  return axios.post(`${baseUrl}/case/${caseId}/arbitrator`, { user_id: userId }, auth(token));
}

export function getArbitrators(token) {
  return axios.get(`${baseUrl}/arbitrators`, auth(token));
}
